import { Operator, Query } from "@/data/base_classes/query";
import { Filter, FilterValue } from "./types.d";

export function formatFiltersAsQueries(filters: Filter[]): Query[] {
  return filters
    .filter(
      (f) =>
        f.value !== undefined &&
        f.value !== null &&
        f.value !== "" &&
        f.value !== FilterValue.EMPTY &&
        f.value?.length !== 0,
    )
    .map((filter) => {
      // Range
      if (filter.type === "range") {
        if (filter.value[0] === filter.min && filter.value[1] === filter.max) {
          return [];
        }
        return [
          new Query(
            filter.key,
            Operator.GREATER_THAN_OR_EQUAL,
            filter.value[0],
          ),
          new Query(filter.key, Operator.LESS_THAN_OR_EQUAL, filter.value[1]),
        ];
      }

      // Handle IS_EMPTY and NOT_EMPTY special filter values
      if (filter.value === FilterValue.IS_EMPTY) {
        return [new Query(filter.key, Operator.EQUALS, null)];
      }

      if (filter.value === FilterValue.NOT_EMPTY) {
        return [new Query(filter.key, Operator.NOT_EQUALS, null)];
      }

      // Format value
      if (filter.type === "date" && filter.value) {
        filter.value = new Date(filter.value).toISOString();
      }

      // Determine the operator
      let operator = Operator.EQUALS;
      if (filter.multiple && !filter.toMany) {
        operator = Operator.IN;
      }

      return [new Query(filter.key, operator, filter.value)];
    })
    .flat();
}
